import React, {useEffect, useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  ButtonVariant,
  FormItem,
  useKeyboardShortcut,
  useModal,
  useToast
} from '@fs/uikit-react';
import styles from './ContactLinkCategoryModal.module.css';
import {ApiError} from "@/services/api";
import { ContactLinkCategoriesApi } from "@/shared/api/ContactLinkCategoriesApi.ts";
import { ContactLinkCategory } from "@/shared/model/contactLinkCategory.ts";

export enum ModalMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

interface ContactLinkCategoryModalProps {
  mode: ModalMode;
  item?: ContactLinkCategory;
  onSuccess: () => void;
}

const ContactLinkCategoryModal: React.FC<ContactLinkCategoryModalProps> = ({ mode, item, onSuccess }) => {
  const { closeModal } = useModal();
  const toast = useToast();
  const isEditMode = mode === ModalMode.EDIT;

  const [name, setName] = useState(item?.name || '');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isEditMode && item) {
      setName(item.name);
    }
  }, [isEditMode, item]);

  const handleSubmit = async () => {
    if (!name) {
      toast.showErrorToast('Помилка валідації', 'Будь ласка, заповніть назву категорії');
      return;
    }

    setIsLoading(true);
    try {
      if (isEditMode && item) {
        await ContactLinkCategoriesApi.update(item.id, { name });
        toast.showSuccessToast('Успішно', 'Категорію оновлено');
      } else {
        await ContactLinkCategoriesApi.create({ name });
        toast.showSuccessToast('Успішно', 'Категорію створено');
      }
      closeModal();
      onSuccess();
    } catch (error) {
      console.error(`Error ${isEditMode ? 'updating' : 'creating'} contact link category:`, error);
      toast.showErrorToast(
        `Помилка ${isEditMode ? 'оновлення' : 'створення'} категорії`,
        getUserFriendlyErrorMessage(error as ApiError)
      );
    } finally {
      setIsLoading(false);
    }
  };

  useKeyboardShortcut('Enter', [], handleSubmit);

  return (
    <div className={styles.modalContent}>
      <FormItem
        label="Назва"
        placeholder="введіть назву"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <div className={styles.buttonGroup}>
        <Button
          title={isLoading ? (isEditMode ? 'Збереження...' : 'Створення...') : (isEditMode ? 'Зберегти' : 'Створити')}
          onClick={handleSubmit}
          loading={isLoading}
        />
        <Button
          title="Скасувати"
          onClick={closeModal}
          variant={ButtonVariant.SECONDARY}
        />
      </div>
    </div>
  );
};

export default ContactLinkCategoryModal;
